import React from 'react';
import styled from 'styled-components';
import LinksList from './LinksList';
import $ from 'jquery';

const MobileDiv = styled.div`
  position: relative;
`;

const Sandwich = styled.div`
  position: relative;
  z-index: 1500;
  display: block;
  @media (min-width: 700px) {
    display: none;
    width: 0;
    height: 0;
  }
  div {
    width: 20px;
    height: 2px;
    background-color: black;
    &:nth-child(2),
    &:last-child {
      margin-top: 3px;
    }
    transition: 0.3s;
  }
`;

const MobileLinks = styled.div`
  opacity: 0;
  z-index: -1;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding-bottom: 60%;
  background-color: black;
  /* handles disappear transitioning */
  transition: height 0.3s ease-in-out 0.1s, opacity 0.3s ease-in-out,
    z-index 0.1s linear 0.3s;
  a {
    color: white;
  }
`;

const animateButton = () => {
  const position = ['top', 'middle', 'bottom'];
  const sandwich = $('#sandwich');

  sandwich
    .children()
    .each((index, item) => $(item).toggleClass(`toggle-${position[index]}`));
};

const toggleLinks = () => {
  animateButton();
  $('#mobile-links').toggleClass('show-mobile-links');
};

export default () => (
  <MobileDiv>
    <Sandwich id="sandwich" data-toggled="false" onClick={toggleLinks}>
      <div id="bar-1" />
      <div id="bar-2" />
      <div id="bar-3" />
    </Sandwich>
    <MobileLinks id="mobile-links" onClick={toggleLinks}>
      <LinksList />
    </MobileLinks>
  </MobileDiv>
);



// WEBPACK FOOTER //
// ./src/components/Header/MobileLinks.js